import Button from './Button/Button.css';
import Counter from './Counter/Counter.css';
import Checkbox from './Checkbox/Checkbox.css';
import ModalPriceBlock from './ModalPriceBlock/ModalPriceBlock.css';
import CloseIcon from './CloseIcon/CloseIcon.css';
import TabsList from './TabsList/TabsList.css';

const Shared = {
	Button: Button,
	Counter: Counter,
	Checkbox: Checkbox,
	ModalPriceBlock: ModalPriceBlock,
	CloseIcon: CloseIcon,
	TabsList: TabsList
};

export default Shared;
